export default "__VITE_ASSET__C$wzsPT$__"